export default {
  primary: "#6c3e83",
  font1: "#222",
  font2: "#444",
  borderInput: "#d1d1d1",
  newBackgroundGrey:"#f9f9f9",
  backgroundGrey: "#f6f7fb",
  graphBgColor: "#eef1ff",
  white: "#ffffff",
  tableHeader: "#ebebef",
  red: "#dc3545",
  backgroundPink: "#f2ecfb",
  hoverTableRow: "#f8f4ff",
  success: "#33cc33",
  warning: "#ffc107",
  tableHeadColor: "#f1f1f1",
  inputErrorBg: "#ffd9d9",
  hoverButtonColor: "#5b336f",
  bgColorFrontend: "#2c1338",
  brandColorFrontend: "#e57cd8",
  frontendFont1: "#412a4c",
  frontendFont2: "#6b5a74",
  newTableHeadCOlor:"#f0f0f0",
  newTableRowHoverBgColor:"#f6f6f6",
  leafGreen: "#2c8c5e",
  lightGrey: "#646464",
  dashBoardLightGrey:"#dae1ff",
};
